import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./GetAPLPage.module.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";

export default function GetAPLPage() {
	const { i18n } = useTranslation();
	const [form, setForm] = useState({
		firstName: "",
		lastName: "",
		businessEmail: "",
		phone: "",
		venue: "",
		location: "",
	});

	const BackgroundImg = IMAGES["MainBackground.png"];

	const handleChange = (e) => {
		const { name, value } = e.target;
		setForm((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	return (
		<div
			className={styles["get-apl-container"]}
			style={{ backgroundImage: `url(${BackgroundImg})` }}
		>
			<div className={styles["get-apl-card"]}>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						marginBottom: "20px",
					}}
				>
					<h2 className={styles["get-apl-card-title"]}>
						{getTranslation(i18n, "getAPLPage.title")}
					</h2>
				</div>
				<p className={styles["subtitle"]}>
					{getTranslation(i18n, "getAPLPage.subtitle")}
				</p>
				<form
					onSubmit={handleSubmit}
					className={styles["animated-form"]}
				>
					<div className={styles["get-apl-form-row"]}>
						<label
							className={`${styles["form-label"]} ${styles["form-field-1"]}`}
						>
							{getTranslation(i18n, "getAPLPage.form.firstName")}
							<input
								className={`${styles["form-input"]} ${styles["animated-input"]}`}
								type="text"
								name="firstName"
								placeholder={getTranslation(
									i18n,
									"getAPLPage.form.firstNamePlaceholder"
								)}
								value={form.firstName}
								onChange={handleChange}
								required
							/>
						</label>
						<label
							className={`${styles["form-label"]} ${styles["form-field-1"]}`}
						>
							{getTranslation(i18n, "getAPLPage.form.lastName")}
							<input
								className={`${styles["form-input"]} ${styles["animated-input"]}`}
								type="text"
								name="lastName"
								placeholder={getTranslation(
									i18n,
									"getAPLPage.form.lastNamePlaceholder"
								)}
								value={form.lastName}
								onChange={handleChange}
								required
							/>
						</label>
					</div>

					<label
						className={`${styles["form-label"]} ${styles["form-field-2"]}`}
					>
						{getTranslation(i18n, "getAPLPage.form.businessEmail")}
						<input
							className={`${styles["form-input"]} ${styles["animated-input"]}`}
							type="email"
							name="businessEmail"
							placeholder={getTranslation(
								i18n,
								"getAPLPage.form.businessEmailPlaceholder"
							)}
							value={form.businessEmail}
							onChange={handleChange}
							required
						/>
					</label>

					<div className={styles["get-apl-form-row"]}>
						<label
							className={`${styles["form-label"]} ${styles["form-field-1"]}`}
						>
							{getTranslation(i18n, "getAPLPage.form.phone")}
							<input
								className={`${styles["form-input"]} ${styles["animated-input"]}`}
								type="text"
								name="phone"
								placeholder={getTranslation(
									i18n,
									"getAPLPage.form.phonePlaceholder"
								)}
								value={form.phone}
								onChange={handleChange}
								required
							/>
						</label>
						<label
							className={`${styles["form-label"]} ${styles["form-field-1"]}`}
						>
							{getTranslation(i18n, "getAPLPage.form.venue")}
							<input
								className={`${styles["form-input"]} ${styles["animated-input"]}`}
								type="text"
								name="venue"
								placeholder={getTranslation(
									i18n,
									"getAPLPage.form.venuePlaceholder"
								)}
								value={form.venue}
								onChange={handleChange}
								required
							/>
						</label>
					</div>
					<label
						className={`${styles["form-label"]} ${styles["form-field-1"]}`}
					>
						{getTranslation(i18n, "getAPLPage.form.location")}
						<input
							className={`${styles["form-input"]} ${styles["animated-input"]}`}
							type="text"
							name="location"
							placeholder={getTranslation(
								i18n,
								"getAPLPage.form.locationPlaceholder"
							)}
							value={form.location}
							onChange={handleChange}
							required
						/>
					</label>

					<button
						type="submit"
						className={`${styles["form-button"]} ${styles["animated-submit-button"]} ${styles["form-field-4"]}`}
					>
						{getTranslation(i18n, "getAPLPage.submitButton")}
					</button>
				</form>
			</div>
		</div>
	);
}
